/*==================== Header ====================*/
/**
 * @param header
 */
export const header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	mobile: function () {
		$(".header-hamburger").on("click", function () {
			$(this).toggleClass("active");
			$('.mobile-wrap').toggleClass("active");
			$('.backdrop-mobile').fadeToggle();
		});
		$(document).on('click', function (e) {
			if (!$(e.target).closest($('.mobile-wrap')).length && !$(e.target).closest($('.header-hamburger')).length) {
				$('.mobile-wrap').removeClass('active');
				$('.backdrop-mobile').fadeOut();
				$('.header-hamburger').removeClass('active');
			}
		});
	},
	mapping: function () {
		// mapping menu
		const megaMenu = $(".mega-product-menu").mapping({
			mobileWrapper: "",
			mobileMethod: "",
			desktopWrapper: "header .is-product-append",
			desktopMethod: "appendTo",
			breakpoint: 0,
		});
		const mainMenu = $(".header-bot .main-menu").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "prependTo",
			desktopWrapper: ".header-bot",
			desktopMethod: "prependTo",
			breakpoint: 1199.98,
		});
		const headerButton = $(".header-top .header-button").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "appendTo",
			desktopWrapper: ".header-top",
			desktopMethod: "prependTo",
			breakpoint: 1023.98,
		});
		const headerSearch = $(".header-top .searchbox").mapping({
			mobileWrapper: ".search-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: ".header-top .header-search",
			desktopMethod: "appendTo",
			breakpoint: 767.98,
		});
		// add arrow dropdown
		if (window.matchMedia("(max-width: 1199.98px)").matches) {
			$('<i class="toggle-menu fa-solid fa-chevron-down"></i>').insertAfter( "li.menu-item-has-children > a");
			$("li.menu-item-has-children .toggle-menu").on("click", function () {
				$(this).toggleClass('active')
				$(this).parent().find("> .sub-menu").slideToggle();
			});
		}
	},
	search: function () {
		$(".header-search-button").on("click", function () {
			$(".search-wrap").fadeToggle();
			$(".backdrop-search").fadeToggle();
			$(".search-input").focus();
		});
		$(document).on("click", function (e) {
			if (!$(e.target).closest(".search-wrap").length && !$(e.target).closest(".header-search-button").length) {
				$(".search-wrap").fadeOut();
				$(".backdrop-search").fadeOut();
			}
		});
	},
	init: function () {
		header.scrollActive();
		header.mobile();
		header.mapping();
		header.search();
	},
};
document.addEventListener("scroll", function (e) {
	header.scrollActive();
}, true);
